/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor200,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor404,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor500,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponse,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor.ts";
import { individualPaymentEditorViewModelSchema } from "../individualPaymentEditorViewModelSchema.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorPathParams>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor200Schema =
  z.lazy(
    () => individualPaymentEditorViewModelSchema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor404Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor500>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditor200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidEditorQueryResponse>;
